/**
 * Obtém o ID da empresa atual do localStorage
 * @returns {string|null} ID da empresa ou null
 */
export function getCurrentCompanyId() {
  return localStorage.getItem('@current_company_id');
}

/**
 * Adiciona companyId aos params (para GET/DELETE) ou body (para POST/PUT)
 * @param {object} params - Parâmetros existentes
 * @param {string} method - Método HTTP (GET, POST, PUT, DELETE)
 * @returns {object} Parâmetros com companyId adicionado
 */
export function addCompanyIdToRequest(params = {}, method = 'GET') {
  const companyId = getCurrentCompanyId();
  
  if (!companyId) {
    return params;
  }

  // Para GET e DELETE, adiciona nos query params
  if (method === 'GET' || method === 'DELETE') {
    return {
      ...params,
      companyId: companyId
    };
  }

  // Para POST/PUT/PATCH, retorna o objeto para ser adicionado ao body
  return {
    ...params,
    companyId: companyId
  };
}

